import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISearchSortProps } from "./SearchSortProps";
import { SortWrapper } from "./SearchSortHelpers";
import Dropdown from "react-bootstrap/Dropdown";
const SearchSort = ({ sortOrder, handleSortChange }: ISearchSortProps) => {
  const [sortDrop, setsortDrop] = useState("Relevance");
  const handleSetSort = (event: any) => {
    const newSortBy = event;
    if (event === "distance") {
      setsortDrop("Nearest Hotel");
    } else if (event === "price") {
      setsortDrop("Lowest Price");
    } else {
      setsortDrop("Relevance");
    }
    handleSortChange(newSortBy, sortOrder);
  };
  return (
    <SortWrapper>
      <Dropdown>
        <Dropdown.Toggle variant="filter-dropdown" id="sort-dropdown">
          <span>{`Sort: ${sortDrop} `}</span>
          <FontAwesomeIcon icon="chevron-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu as={`ul`} id={"sort-drop-down"}>
          <li>
            <Dropdown.Item eventKey={"relevance"} onSelect={handleSetSort}>
              Sort: Relevance
            </Dropdown.Item>
            <Dropdown.Item eventKey={"distance"} onSelect={handleSetSort}>
              Sort: Nearest Hotel
            </Dropdown.Item>

            <Dropdown.Item eventKey={"price"} onSelect={handleSetSort}>
              Sort: Lowest Price
            </Dropdown.Item>
          </li>
        </Dropdown.Menu>
      </Dropdown>
    </SortWrapper>
  );
};
export default React.memo(SearchSort);
